import { DiscoveryItem } from '@wconcept/wconcept-common/models/renewal/discovery';
import { ShortFormAdInfo } from '@wconcept/wconcept-common/models/renewal/moloco';
import {
  ContentItem,
  StyleclipContent,
} from '@wconcept/wconcept-common/models/renewal/styleclip';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface RelatedProductModalStore {
  productIds: string[];
  setProductIds: (productIds: string[]) => void;
  getProductIds: () => string[];
  content: ContentItem | StyleclipContent | DiscoveryItem | null;
  setContent: (content: ContentItem | StyleclipContent | DiscoveryItem) => void;
  getContent: () => ContentItem | StyleclipContent | DiscoveryItem | null;
  contentType: 'video' | 'image' | null;
  setContentType: (contentType: 'video' | 'image') => void;
  getContentType: () => 'video' | 'image' | null;
  index: number;
  setIndex: (index: number) => void;
  getIndex: () => number;
  adContent: ShortFormAdInfo | null;
  setAdContent: (content: ShortFormAdInfo) => void;
  getAdContent: () => ShortFormAdInfo | null;
}

const useRelatedProductModalStore = create<RelatedProductModalStore>()(
  persist(
    (set, get) => ({
      content: null,
      index: -1,
      setContent: (content: ContentItem | StyleclipContent | DiscoveryItem) => {
        set({ content });
      },
      getIndex: () => get().index,
      setIndex: (index: number) => set({ index }),
      productIds: [],
      setProductIds: (productIds: string[]) => set({ productIds }),
      getProductIds: () => get().productIds,
      getContent: () => get().content,
      contentType: null,
      setContentType: (contentType: 'video' | 'image') => set({ contentType }),
      getContentType: () => get().contentType,
      adContent: null,
      setAdContent: (adContent: ShortFormAdInfo) => set({ adContent }),
      getAdContent: () => get().adContent,
    }),
    {
      name: 'related-product-storage', // 스토리지에 저장될 키 이름
      storage: createJSONStorage(() => sessionStorage), // 세션 스토리지 사용
      partialize: state => ({
        productIds: state.productIds,
        content: state.content,
        contentType: state.contentType,
        index: state.index,
        adContent: state.adContent,
      }), // 저장할 state 지정
    }
  )
);

export { useRelatedProductModalStore };
